import { AlertCircle } from 'lucide-react'

import { cn } from '@/shared/ui/cn'

type FormErrorSummaryProps = {
  count: number
  className?: string
}

function FormErrorSummary({ count, className }: FormErrorSummaryProps) {
  if (count <= 0) return null
  return (
    <p
      role="alert"
      data-slot="form-error-summary"
      className={cn(
        'flex items-center gap-1.5 text-sm font-medium text-destructive',
        className,
      )}
    >
      <AlertCircle aria-hidden className="size-4 shrink-0" />
      {count === 1
        ? 'Fix 1 field before saving'
        : `Fix ${count} fields before saving`}
    </p>
  )
}

export { FormErrorSummary }
export type { FormErrorSummaryProps }
